import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  List,
  ListItem,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { PrimaryBtn, CancelBtn, dialogPaperSx, dialogTitleSx } from "./ui";
import { useTheme } from "../context/ThemeContext";

export default function DuplicateFileDialog({
  open,
  duplicateFiles = [],
  onReplaceAll,
  onSkip,
  onCancel,
  mode = "replace",
}) {
  const { isDark } = useTheme();
  const isSingle = duplicateFiles.length === 1;
  const isOrgConflict = mode === "org_conflict";

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{ sx: dialogPaperSx(isDark) }}
    >
      <DialogTitle sx={dialogTitleSx(isDark)}>
        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <WarningAmberRoundedIcon
            sx={{ fontSize: "20px", color: "#F59E0B" }}
          />
          {isSingle ? "Duplicate file detected" : "Duplicate files detected"}
        </Box>
        <IconButton
          onClick={onCancel}
          size='small'
          disableRipple
          sx={{
            color: isDark ? "#A8AEB6" : "#434950",
            height: "36px",
            width: "36px",
            borderRadius: "10px",
            "&:hover": { background: isDark ? "#434950" : "#D5D9DF" },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        {isSingle ? (
          <Typography
            sx={{
              fontFamily: "Inter",
              fontSize: "14px",
              color: isDark ? "#A8AEB6" : "#6A7079",
            }}
          >
            A file named "<b>{duplicateFiles[0]}</b>" already exists. What would you like to do?
          </Typography>
        ) : (
          <>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontSize: "14px",
                color: isDark ? "#A8AEB6" : "#6A7079",
              }}
            >
              These files already exist:
            </Typography>
            <List dense sx={{ p: 0, mt: "4px" }}>
              {duplicateFiles.map((file, i) => (
                <ListItem key={i} sx={{ p: 0 }}>
                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontSize: "14px",
                      color: isDark ? "#A8AEB6" : "#6A7079",
                    }}
                  >
                    • {file}
                  </Typography>
                </ListItem>
              ))}
            </List>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontSize: "14px",
                color: isDark ? "#A8AEB6" : "#6A7079",
                mt: "8px",
              }}
            >
              What would you like to do?
            </Typography>
          </>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 0, mt: "20px", justifyContent: "flex-end", gap: "12px" }}>
        <CancelBtn onClick={onSkip} disableRipple isDark={isDark}>
          Skip {isSingle ? "file" : "duplicates"}
        </CancelBtn>
        <PrimaryBtn onClick={onReplaceAll} disableRipple isDark={isDark}>
          {isOrgConflict ? (isSingle ? "Add anyway" : "Add all anyway") : (isSingle ? "Replace file" : "Replace all")}
        </PrimaryBtn>
      </DialogActions>
    </Dialog>
  );
}
